<template>
    <div>
        <title>总数</title>
        <article class="cardArticle">
            <header class="tabHeader">
                <p>
                    <router-link :to="{path:'/OperateRecord'}" v-if="openStoreDefinition==1">定义激活记录</router-link>
                    <router-link :to="{path:'/ActivationRecord'}" class="isActive">激活记录</router-link>
                    <router-link :to="{path:'/PauseRecord'}" >暂停记录</router-link>
                    <router-link :to="{path:'/ReuseRecord'}" >恢复记录</router-link>
                    <router-link :to="{path:'/RecoverRecord'}" v-if="ElementControls('erjimendian')==1">销售回收记录</router-link>
                    <router-link :to="{path:'/SpreadRecordMd'}"  v-if="ElementControls('erjimendian')==1">铺券记录</router-link>
                </p>
            </header>
            <ActivationRecord></ActivationRecord>
        </article>
        
    </div>
</template>
<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
export default {
    name:'CardRecordTotal',
    components: {
      Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
      OutDetail: resolve => require(["@/components/CardsFolder/OutDetail.vue"], resolve),//出库详情弹框
      ActivationRecord: resolve => require(["@/components/common/ActivationRecord.vue"], resolve),
    },
    data(){
        return{
            openStoreDefinition:0,
            statetype:'当前状态',
            cardInfo:'',
            batchcode:'',
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            cardBatchStatistics:'',
            cardBatchCodeList:[],
            // 检索表单
            totalForm:{
                code:'',//关键词
                state:'',//状态
            },
            // 表格数据
            recordData:[],
            outDetailDialogVisible:false,//出库详情弹框
            totalIndex:-1,//当前选中总数
            totalData:[
                {
                    num:10,
                    totalText:'总数'
                },{
                    num:1,
                    totalText:'未激活'
                },{
                    num:1,
                    totalText:'未提货'
                },{
                    num:1,
                    totalText:'部分提货'
                },{
                    num:1,
                    totalText:'已提货'
                },{
                    num:1,
                    totalText:'已回收'
                },{
                    num:1,
                    totalText:'重新出库'
                },{
                    num:1,
                    totalText:'已暂停使用'
                },{
                    num:1,
                    totalText:'已作废'
                }
            ],
            tableHeight: window.innerHeight*.8, //表格动态高度
        }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    // ==================================== 方法 ====================================
    watch: {
      "totalForm.state":function(val){
         if(val=='5'){
              this.statetype = '回收前状态';
            } else if(val=='7'){
              this.statetype = '重新出库时状态';
            }else {
               this.statetype = '当前状态';
            }
            this.pageSize =30;
            this.currentPage =1;
            this.getCardBatchCodeList();
      }
    },
    methods:{
        //查询
        query(){
          this.pageSize =30;
          this.currentPage =1;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 分页
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.$refs.gsTable.bodyWrapper.scrollTop = 0;
          this.getCardBatchCodeList();
        },
        // 打开出库详情弹框
        getCoverDetailShow(code){
            Api.GET_CARDINFODET({code:code}).then(res =>{
               if(res.data.status=="200"){
                  if(res.data.data.codeinfo){
                    this.cardInfo = res.data.data.codeinfo;
                    this.outDetailDialogVisible = true;
                  }
               }
            })
        },
        // 关闭出库详情弹框
        getCloseOutDetailCld(){
            this.outDetailDialogVisible = false;
        },
        // 切换各种状态
        getTotalTab(totalIndex){
            if(totalIndex=='5'){
              this.statetype = '回收前状态';
            } else if(totalIndex=='7'){
              this.statetype = '重新出库时状态';
            }else {
               this.statetype = '当前状态';
            }
            this.totalIndex = totalIndex;
            if(totalIndex==-1){
              this.totalForm.state = '';
            }else{
              this.totalForm.state = totalIndex;
            }
            this.pageSize = 30;
            this.currentPage = 1;
            this.totalForm.code ='';
            this.getCardBatchCodeList();
        },
        // 返回上一页
        goBack(){
            window.history.back();   
        },
        //动态获取表格高度
        getHeight() {
          // if(this.$refs.gsTable.$el.offsetTop){
          //   let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
          //   //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
          //   this.tableHeight = window.innerHeight - tbHeight - 125; 
          // } 
        },
        // 数量使用情况
        getCardBatchStatistics(){
           let param = {
              batchcode:this.batchcode,
              opertype:1
            }
          Api.GET_CARDBATCHSTATISTICS(param).then(res =>{
            if(res.data.status=="200"){
              this.cardBatchStatistics = res.data.data;
            }else{
              this.cardBatchStatistics= '';
            }
          })
        },
        // 批次内编码详情列表
        getCardBatchCodeList(){
           let param = {
               batchcode:this.batchcode,
               opertype:1,
               code:this.totalForm.code,
               state:this.totalForm.state,
               pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                }
           }
          Api.GET_CARDBATCHCODELIST(param).then(res =>{
             if(res.data.status=="200"){
                 this.cardBatchCodeList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
              }else {
                 this.pageTotal =0;
                 this.cardBatchCodeList =[];
              }
          })
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
      this.openStoreDefinition = this.ElementControls('openStoreDefinition')
        if(this.$route.query.batchcode){
          this.batchcode = this.$route.query.batchcode;
          this.getCardBatchCodeList();
          this.getCardBatchStatistics();
        }
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.cardArticle{
    position: relative;
    padding: 84px 20px 20px 20px;
    height: calc(100% - 169px);
}

</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardRecord/ActivationRecordTotal.vue